var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoLandscapeTb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.73 36.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0093e0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico-landscape-tb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.9,15.3H21.42V3.83A3.83,3.83,0,0,0,17.6,0H3.83A3.84,3.84,0,0,0,0,3.83V32.9a3.84,3.84,0,0,0,3.83,3.83H32.9a3.84,3.84,0,0,0,3.83-3.83V19.13A3.84,3.84,0,0,0,32.9,15.3Zm-13,17.6a2.3,2.3,0,0,1-2.29,2.3H3.83a2.3,2.3,0,0,1-2.3-2.3V30.61H19.89Zm0-3.82H1.53V7.65H19.89Zm0-23H1.53V3.83a2.3,2.3,0,0,1,2.3-2.3H17.6a2.3,2.3,0,0,1,2.29,2.3ZM29.08,35.2H20.64a3.75,3.75,0,0,0,.78-2.3V16.83h7.66Zm6.12-2.3a2.3,2.3,0,0,1-2.3,2.3H30.61V16.83H32.9a2.3,2.3,0,0,1,2.3,2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.72,1.53a.77.77,0,1,0,0,1.53,8.43,8.43,0,0,1,8.4,8L30.37,9.39a.76.76,0,0,0-1.08,0,.77.77,0,0,0,0,1.08c1.24,1.18,2.61,2.53,2.92,2.87a.75.75,0,0,0,.67.4.79.79,0,0,0,.58-.25l3-3a.76.76,0,1,0-1.08-1.08l-1.77,1.77A10,10,0,0,0,23.72,1.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLandscapeTb);
export default __webpack_public_path__ + "static/media/ico-landscape-tb.62e1dfca7804073497e4cef78a3f00bb.svg";
export { ForwardRef as ReactComponent };